<template id="login">
  <section>
  <div class="login-container">
    <div class="login-page">
      <b-overlay :show="show" rounded="lg">
        <h1>Login</h1>
        <form action="" name="cform" v-on:submit.prevent="login">
          <div class="form-group">
            <label for="exampleInputEmail0" class="float-left">User Name</label>
            <input
                type="text"
                class="form-control"
                id="exampleInputEmail0"
                aria-describedby="emailHelp"
                v-model="f.userName"
                required
                placeholder="Enter your UserName"
            />
          </div>
          <div class="form-group">
            <label for="exampleInputEmail1" class="float-left">Password</label>
            <div class="input-group">
              <input
                  :type="showPassword ? 'text' : 'password'"
                  class="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                  v-model="f.password"
                  required
                  placeholder="Enter your Password"
              />
              <div class="input-group-append">
                <button
                    class="btn btn-outline-secondary"
                    type="button"
                    @click="togglePasswordVisibility"
                >
                  <i :class="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                </button>
              </div>
            </div>
            <a v-on:click="forgotPass()" style="color: #0b57d0; cursor: pointer">
              {{ unlockUser ? 'Unlock User?' : 'Forgot Password?' }}
            </a>
          </div>


          <!--Alert Messages-->
          <div class="alert alert-danger" v-if="$store.state.serverIsDown">Server Seems to be down.</div>
          <div class="alert alert-danger" v-if="$store.state.serverIsDown">Please Contact Administrator</div>
          <div class="alert alert-danger" v-if="loginFailed">{{ errorTitle }}</div>
          <div>
          <button type="submit" class="btn btn-primary">
            Login
          </button>
          </div>
        </form>
      </b-overlay>
    </div>
    <forgotPass ref="forgotPass" :unlock-user="unlockUser"></forgotPass>
  </div>
    <!-- PWA Install Button (centered under Login) -->
    <div class="pwa-install">
      <button id="install" class="pwa-install-btn" hidden>
        Add to Home Screen
      </button>
    </div>
  </section>
</template>

<script>
import axios from 'axios';
import forgotPass from './forget_password.vue';
import Menu from '@/components/menu.vue';
import { bus } from '@/bus';

export default {
  name: 'login',
  // eslint-disable-next-line vue/no-unused-components
  components: {forgotPass,Menu},
  data() {
    return {
      show: false,
      showPassword: false, // Initialize state for password visibility
      f: {
        userName: '',
        password: '',
      },
      loginFailed: false,
      errorTitle: '',
      isLogin:true,
      isForgotPass: false,
      deferredPrompt: null,
      unlockUser:false
    };
  },
  created() {
    if (this.$store.state.isLoggedIn) {
      // no need to login again
      this.$router.push('/')
    }
    // Detect device type when component loads
    // this.detectDeviceType();
  },
  mounted() {
    const installButton = document.getElementById('install');

    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      this.deferredPrompt = e;
      console.log("before install prompt event fired");
      installButton.hidden = false;
    });

    installButton.addEventListener('click', async () => {
      if (!this.deferredPrompt) {
        console.log("deferredPrompt is null, install prompt not available.");
        return;
      }
      this.deferredPrompt.prompt();
      const { outcome } = await this.deferredPrompt.userChoice;
      console.log(`User response to install prompt: ${outcome}`);
      this.deferredPrompt = null;
      installButton.hidden = true;
    });
  },
  methods: {
    // async detectDeviceType() {
    //   const userAgent = navigator.userAgent.toLowerCase();
    //   console.log("userAgent",userAgent);
    //   let deviceType = 'Desktop'; // Default
    //
    //   // Check for mobile devices
    //   if (/mobile|android|iphone|ipad|ipod/.test(userAgent)) {
    //     deviceType = 'Mobile';
    //   }
    //
    //   // Optional: Check screen width (alternative method)
    //   if (window.innerWidth <= 768 && deviceType === 'Desktop') {
    //     deviceType = 'Mobile'; // Small screen, likely mobile
    //   }
    //
    //   // Store in Vuex
    //   await this.$store.commit('setDeviceType', deviceType);
    // },
    // async handleSubmit(){
    //   if(this.isLogin) await this.login()
    //   else if (this.isForgotPass) await this.forgotPass()
    // },
    async login() {
      this.isLogin=true
      this.isForgotPass=false
      this.loginFailed = false
      this.$store.state.authRequired = false
      this.show = true
      try {
        let response = await axios.post(`/auth/login`, this.f)

        await this.handleLogin(response.data)
      } catch (error) {
        this.errorTitle = error.response && error.response.data ? error.response.data.error : 'Something went wrong';
        if(this.errorTitle.includes('Your account is locked')) {
          this.unlockUser = true
          // this.$refs.forgotPass.show()
        }
        await this.$store.commit('authError');
        this.loginFailed = !this.$store.state.serverIsDown;
        this.show = false;
      }

    },
    async handleLogin(response) {
      if (response['authToken']) {
        await this.$store.commit('loggedIn', response['authToken']);
        this.$store.commit('isAppMenuAndAppHeaderDisplay', true)
        await this.$store.dispatch('checkUserLogin');
        await this.$store.dispatch("loadState");
        await this.$store.dispatch('loadAnnotations');
        this.show = false;
        // Get the stored return URL
        const returnUrl = sessionStorage.getItem('returnUrl');
        console.log("returnUrl",returnUrl)
        if (this.$store.state.user.enforcePasswordReset) {
          await this.$router.push('/change-password');
        }else if(this.$store.state.user.enforceRnPageOnLogin){
          await this.$router.push('/release-notes');
          await axios.get(`/auth/release-notes`);
        }
        else if(this.$store.state.deviceType==='Mobile'){
          // Get mobile path - user config overrides role config
          const mobilePath = this.$store.state.user.deviceLandingPageConfig?.mobile ??
              this.$store.state.userRoleRestriction.deviceLandingPageConfig?.mobile;
          console.log("mobilePath",mobilePath);
          await this.$router.push(mobilePath);
        }
        else {
          let url = returnUrl? returnUrl:'/';
          await this.$router.push(url);
        }
        //call homedah
        bus.$emit('call-home-menu');

      } else {
        console.error('Login Failed?', response);
        this.loginFailed = true;
        this.show = false;
      }
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    async forgotPass(){
      this.isLogin=false
      this.isForgotPass=true
      this.$refs.forgotPass.show()

    },
  },
};
</script>

<style scoped>
.login-container {
  display: flex;
  width: 100%;
  min-height: 75vh;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
}

.login-page {
  max-width: 400px;
  width: 100%;
  padding: 3rem;
  box-shadow: 1px 2px 2px 3px #a7aeaa;
  border-radius: 8px;
  background: white;
}

@media (max-width: 768px) {
  .login-page {
    width: 300px;
    padding: 2rem;
  }
}

.input-group-append {
  border: 0px solid #a7aeaa;
}

.form-group, .input-group, .alert, a {
  text-align: left;
}

.pwa-install {
  width: 100%;
  display: flex;
  justify-content: center;
  /*margin-top: 20px;
  margin-bottom: 20px;*/
}

.pwa-install-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: #4285f4;
  color: white;
  border: none;
  border-radius: 50px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
}

.pwa-install-btn:hover {
  background: #3367d6;
}
</style>